import React from "react";
import { Legend, Pie, PieChart, Tooltip, Cell } from "recharts";
import "./styles.css";

const Spirax = () => {
  const statusData = [
    { name: "Failed Closed", value: 1, color: "#d81b60" },
    { name: "Failed Open", value: 1, color: "#f39c12" },
    { name: "Offline", value: 49, color: "#37474f" },
    { name: "Anomaly", value: 1, color: "#8e24aa" },
    { name: "Okay", value: 25, color: "#26a69a" },
  ];

  const total = statusData.reduce((sum, entry) => sum + entry.value, 0);

  return (
        <div className="container">
            {/* Pie Chart */}
            <div className="pie-style">
                <PieChart width={1000} height={500}>
                <Pie
                    data={statusData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    //outerRadius={100}
                    //label
                >
                    {statusData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Pie>
                <Tooltip/>
                <Legend verticalAlign="bottom" height={36} />
                </PieChart>
            </div>

            {/* Status Summary Bar */}
            <div className="status-container">
                {statusData.map((item, index) => (
                <div
                    key={index}
                    className="status-box"
                    style={{ backgroundColor: item.color }}
                >
                    <span className="value">{item.value}</span>
                    <span className="label">{item.name}</span>
                </div>
                ))}
                <div className="total-box">
                <span className="total-value">{total}</span>
                <span className="total-label">Total Sensors</span>
                </div>
            </div>
        </div>
  );
};

export default Spirax;